<template>
    <div class="form-group is-radio">
        <label class="placeholder" :for="getFieldId" v-text="placeholder"></label>
        <div class="options">
            <label v-for="(option, index) in options" :for="(option + '_' + _uid)">
                <input :id="(option  + '_' + _uid)" type="radio" @click="updateValue(option)" :name="name" :value="option" ref="input"> {{ option }}
            </label>
        </div>
    </div>
</template>

<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        props: {
            options: {
                type: Array,
                required: true,
            },
        },
    }
</script>